<div class="content-width">
    <ion-text>
        <h5 class="ion-text-center">
            <ion-icon [name]="iconName" color="primary"></ion-icon>
            @if(secondIcon){
                <ion-icon color="secondary" [src]="secondIcon"></ion-icon> 
            }
            <br /> {{ text | translate }}
        </h5>
    </ion-text>
</div>
